import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';
import { useDraftCqrsFind } from '@dreryk/react-draft';

import { getReferralDraftToken } from '../referral.draft';
import { referralTranslationKeys } from '../translations';

import { referralToDiagnosticExaminationDraftSchema } from './referralToDiagnosticExamination.draft';
import { ReferralToDiagnosticExaminationFormBean } from './ReferralToDiagnosticExaminationForm/ReferralToDiagnosticExaminationForm.types';

type ReferralToDiagnosticExaminationPanelChildrenRenderProps = {
   referralToDiagnosticExaminationDraft: ReferralToDiagnosticExaminationFormBean | null;
};

type ReferralToDiagnosticExaminationPanelLoaderProps = {
   readonly visitId: number;
   readonly children: (renderProps: ReferralToDiagnosticExaminationPanelChildrenRenderProps) => JSX.Element;
   readonly electronic: boolean;
};

export const ReferralToDiagnosticExaminationPanelLoader = (
   props: ReferralToDiagnosticExaminationPanelLoaderProps
): JSX.Element => {
   const {
      data: referralToDiagnosticExaminationDraft,
      loading: referralToDiagnosticExaminationDraftLoading,
      error: referralToDiagnosticExaminationDraftError,
   } = useDraftCqrsFind(
      {
         token: getReferralDraftToken(
            props.electronic ? 'electronicReferralToDiagnosticExamination' : 'referralToDiagnosticExamination',
            props.visitId
         ),
      },
      referralToDiagnosticExaminationDraftSchema
   );

   if (referralToDiagnosticExaminationDraftLoading) {
      return <LoaderSpinner />;
   }

   if (referralToDiagnosticExaminationDraftError) {
      return (
         <Message
            testId={'referralToDiagnosticExaminationFetchError'}
            type={MessageType.NEGATIVE}
            label={referralTranslationKeys.referralFetchError}
            displayIndicator
         />
      );
   }

   return props.children({
      referralToDiagnosticExaminationDraft: referralToDiagnosticExaminationDraft?.contents ?? null,
   });
};
